import { useMemo } from 'react';
import { useStudentLearningLanguageSuspenseQuery } from '@lingoda/monolith-graphql';
import { CEFR_CURRICULUM } from '../../constants';
import { ProficiencyContext } from './ProficiencyContext';
import type { PropsWithChildren } from 'react';

export const ProficiencyContextProvider = ({ children }: PropsWithChildren<unknown>) => {
    const { data: learningLanguageData } = useStudentLearningLanguageSuspenseQuery({
        fetchPolicy: 'cache-and-network',
    });
    const { sectionCurricula, student } = learningLanguageData;
    const section = student?.section;
    const curriculum = student?.curriculum;

    const currentSectionCurriculum = useMemo(
        () =>
            sectionCurricula?.find(
                (item) =>
                    item.section.name === section.name && item.curriculum.id === curriculum.id,
            ),
        [sectionCurricula, section.name, curriculum.id],
    );

    const isCEFR = currentSectionCurriculum?.curriculum.name === CEFR_CURRICULUM;
    const sectionSlug = currentSectionCurriculum?.slug || '';

    const contextValue = useMemo(
        () => ({
            isCEFR: !!isCEFR,
            sectionSlug,
        }),
        [isCEFR, sectionSlug],
    );

    return (
        <ProficiencyContext.Provider value={contextValue}>{children}</ProficiencyContext.Provider>
    );
};
